/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  Component,
  OnInit
}                                from '@angular/core';

import { Logger                } from '@/util/logger';

@Component({
  standalone: false,
  templateUrl: 'register.component.html'
})

/**
 *
 * @class RegisterComponent
 *
 * @brief user registration page
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2022
 *
 */
export class RegisterComponent implements OnInit {

  /** standard constructor */
  constructor(
  ) {

  }

  /** on page setup */
  ngOnInit() {

    Logger.debug('[RegisterComponent] init...');



  }

}

